<!------------------------------ DISPLAY MODE  ----------------------------------------->


<div *ngIf="!pageConfig.edit">
    <ng-container *ngIf="!options.noCard; else noCardContent">
        <mat-card class="full" (click)="goItem()">
            <ng-container *ngTemplateOutlet="contactList"></ng-container>
        </mat-card>
    </ng-container>
    <ng-template #noCardContent>
        <div class="full" (click)="goItem()">
            <ng-container *ngTemplateOutlet="contactList"></ng-container>
        </div>
    </ng-template>

    <ng-template #contactList>
        <mat-list *ngIf="pageConfig.loaded">
            <mat-list-item *ngIf="options.displayRef">
                <mat-icon matListIcon>
                    {{GLOBAL.ICONS.CONTACT}}</mat-icon>
                <h3 matLine> I{{item.values.ref}} </h3>
            </mat-list-item>
            <mat-list-item *ngIf="!options.hideFullname" style="padding-right: 30px">
                <mat-icon matListIcon>
                    {{GLOBAL.ICONS.CONTACT}}</mat-icon>
                <h3 matLine> {{item.values.fullname}} </h3>
            </mat-list-item>
            <mat-list-item *ngIf="item.values.nationalities && item.values.nationalities.length">
                <mat-icon matListIcon>
                    {{GLOBAL.ICONS.FLAG}}</mat-icon>
                <h3 matLine>
                    <ng-container *ngFor="let n of item.values.nationalities; let i = index">
                        {{i > 0 ? ', ' : '' }}{{n | param:'countries'}}</ng-container>
                </h3>
            </mat-list-item>
            <mat-list-item *ngIf="item.values.country">
                <mat-icon matListIcon>{{GLOBAL.ICONS.UNIT}}</mat-icon>
                <h3 matLine>{{item.values.country | param:'countries'}}</h3>
            </mat-list-item>
            <mat-list-item>
                <mat-icon matListIcon>
                    {{GLOBAL.ICONS.LANG}}</mat-icon>
                <h3 matLine> {{item.values.lang | param:'langs'}} </h3>
            </mat-list-item>
            <mat-list-item *ngIf="item.values.birthday">
                <mat-icon matListIcon>
                    {{GLOBAL.ICONS.BIRTH}}</mat-icon>
                <h3 matLine> {{item.values.birthday | date:'dd MMM yyyy'}} </h3>
            </mat-list-item>
            <ng-container *ngIf="options.hideContactDetails">
                <mat-list-item>
                    <mat-icon matListIcon color="warn">warning</mat-icon>
                    <h3 matLine>Accept the project to view contact details.</h3>
                </mat-list-item>
            </ng-container>

            <ng-container *ngIf="checkAccessContact() && !options.hideContactDetails">
                <ng-container *ngIf="item.values.tels">
                    <mat-list-item *ngFor="let tel of item.values.tels | toarray">
                        <mat-icon matListIcon>{{GLOBAL.ICONS.PHONE}}</mat-icon>
                        <h3 matLine>
                            <a *ngIf="getTelLink(tel.number)" [href]="getTelLink(tel.number)" (click)="$event.stopPropagation()">{{tel.number}}</a>
                            <span *ngIf="!getTelLink(tel.number)">{{tel.number}}</span>
                            <button mat-icon-button class="call-action" matTooltip="Call on phone"
                                [disabled]="callRequested"
                                (click)="$event.stopPropagation(); requestPhoneCall(tel.number)">
                                <mat-icon>phone_android</mat-icon>
                            </button>
                        </h3>
                    </mat-list-item>
                </ng-container>

                <ng-container *ngIf="item.values.emails">
                    <mat-list-item *ngFor="let email of item.values.emails | toarray">
                        <mat-icon matListIcon>{{GLOBAL.ICONS.EMAIL}}</mat-icon>
                        <h3 matLine>{{email.email}}</h3>
                    </mat-list-item>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!checkAccessContact() && !options.hideContactDetails">
                <mat-list-item *ngFor="let tel of item.values.tels | toarray">
                    <mat-icon matListIcon>{{GLOBAL.ICONS.PHONE}}</mat-icon>
                    <h3 matLine>No Access!</h3>
                </mat-list-item>
            </ng-container>

            <ng-container *ngIf="item.values.synaps?.employeesArray">
                <mat-list-item *ngFor="let e of item.values.synaps?.employeesArray" class="cursor" (click)="goCompany(e.$key)">
                    <mat-icon matListIcon>{{GLOBAL.ICONS.WORK}}</mat-icon>
                    <h3 matLine>{{e.displayname}}</h3>
                </mat-list-item>
            </ng-container>

            <ng-container *ngIf="item.values.synaps?.contactBroker">
                <mat-list-item (click)="goBroker()" [ngClass]="{cursor: checkAccessContact()}">
                    <mat-icon matListIcon>{{GLOBAL.ICONS.BROKER}}</mat-icon>
                    <h3 matLine>{{item.values.synaps.contactBrokerObj?.status | param:"brokerStatus"}} Broker</h3>
                </mat-list-item>
            </ng-container>

            <mat-list-item *ngIf="item.values.synaps?.contactsProjectsArray">
                <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
                <h3 matLine>{{item.values.synaps.contactsProjectsArray.length}}</h3>
            </mat-list-item>

            <mat-list-item *ngIf="item.values.synaps?.ownersArray">
                <mat-icon matListIcon>{{GLOBAL.ICONS.UNIT}}</mat-icon>
                <h3 matLine>{{item.values.synaps.ownersArray.length}}</h3>
            </mat-list-item>
        </mat-list>
    </ng-template>


    <!-- EDIT -->

    <button *ngIf="!options.displayOnly && checkAccessContact()" color="primary" mat-icon-button class="bottom-right" (click)="editItem()">
        <mat-icon>{{GLOBAL.ICONS.EDIT}}</mat-icon>
    </button>

</div>


<!------------------------------ EDIT MODE  ----------------------------------------->


<div class="contactPage" *ngIf="pageConfig.edit">

    <form-builder [item]="item" [values]="item.values" section="main" [edit]="true"></form-builder>
    <form-builder [item]="item" [values]="item.values" section="emails" [edit]="true"> </form-builder>
    <form-builder [item]="item" [values]="item.values" section="tels" [edit]="true"></form-builder>


    <button  color="accent" mat-icon-button class="bottom-right" [disabled]="!item.valid || !item.modified || item.saving"
        (click)="saveItemDisplayItem()">
        <mat-icon>check</mat-icon>
    </button>
    <!-- CANCEL -->
    <button color="basic" mat-icon-button *ngIf="!options.editOnly" class="bottom-right p2"  (click)="cancelEditDisplayItem()">
        <mat-icon>close</mat-icon>
    </button>
</div>